<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" fab v-bind="attrs" v-on="on" height="50px" width="50px">
        <v-icon color="white">mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <div class="padding-card">
         <p class="title-modal">Deposito o Transferencia</p>
         <v-form>
          <v-col>Fecha depósito: <span style="font-weight: bold;">{{ $dayjs(payment.fecha_pago_usuario).format('DD-MM-YYYY') }} {{ payment.hora_pago_usuario }}</span></v-col>
          <v-col>Banco: <span style="font-weight: bold;">{{ payment.banco_origen }}</span></v-col>
          <v-col>Referencia: <span style="font-weight: bold;">{{ payment.referencia_bancaria }}</span></v-col>
          <v-col>Núm movimiento: <span style="font-weight: bold;">{{ payment.numero_movimiento }}</span></v-col>          
          <v-col>Monto: <span style="font-weight: bold;">{{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(payment.monto_reportado) }}</span></v-col>
          <v-col>Fecha registro: <span style="font-weight: bold;">{{ $dayjs(payment.fecha_cofirmacion_usuario).format('DD-MM-YYYY') }}</span></v-col>
         
          <v-col cols="12">  
            <v-text-field 
              dense v-model="motivo" 
              label="Motivo rechazo"
               :rules="[v => v.length <= 100 || 'Máximo 100 caracteres']"></v-text-field>       
          </v-col>
         </v-form>
      </div>
      <v-card-actions>
        <v-btn color="primary" @click="aceptar"> Aceptar </v-btn>
        <v-btn color="primary" @click="rechazar"> Rechazar </v-btn>
        <v-btn color="primary" @click="eliminar"> Eliminar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    payment: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true      
    }
  },
  components: {
   
  },
  data: () => ({
    dialog: false,
    motivo: ''
  }),
  mounted(){
    console.log(this.payment);
    this.motivo= this.payment.motivo_rechazo !== null ? this.payment.motivo_rechazo : '';
  },
  methods:{
    aceptar() {
      this.$emit('aceptar', this.payment.id);
      this.dialog = false;
    },
    rechazar() {
      this.$emit('rechazar', this.payment.id, this.motivo);
      this.dialog = false;
    },
    eliminar(){
     this.$emit('eliminar', this.payment.id);
     this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>